export default __webpack_public_path__ + "static/media/girl_avtar.252d45b5.svg";